/**
 * Copyright 2024-2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export const minSearchLength = 3;
export const maxSearchLength = 100;
export const searchDelay = 600;

export const getNoSearchResultsMessage = (
  minLength: number = minSearchLength
): string => {
  return `No results found for your search. Please enter at least ${minLength} characters to start the search`;
};
